import { useParams } from 'react-router-dom';

import ProjectDetail from '../../features/projects/layouts/detail';
import ProjectsOverview from '../../features/projects/layouts/overview';

export default function ProjectsPage() {
    const { projectId } = useParams();
    const id = Number(projectId);
    if (projectId) return <ProjectDetail key={id} projectId={Number.isInteger(id) && id > 0 ? id : 0} />;
    return <ProjectsOverview />;
}
